var React = require('react');

function Station (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h20v20H0z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.348 4.936c-1.342.672-3.503.747-4.845.074-1.267-.672-1.192-1.719.15-2.466 1.34-.673 3.502-.748 4.844-.075 1.267.673 1.192 1.794-.15 2.467Zm3.503.598c.074-.075.149-.075.149 0l-.075 9.718c0 .373-.223.672-.521.896-2.385 1.645-4.174 2.467-5.367 2.467-1.192 0-2.981-.822-5.366-2.466a1.066 1.066 0 0 1-.447-.898l-.15-9.717C6.685 7.253 8.622 8.15 9.964 8.15c1.416 0 3.354-.897 5.888-2.616ZM4 5.534c.075-.075.075 0 .075 0H4Z","fill":"#fff","key":1})]);
}

Station.defaultProps = {"width":"20","height":"20","fill":"none"};

module.exports = Station;

Station.default = Station;
